/**
 * Placeholder shown before inputs are complete
 * WP-LANDING-3
 */
export function HeatmapPlaceholder() {
  return (
    <div className="py-12 text-center text-gray-500">
      <svg
        className="w-16 h-16 mx-auto mb-4 text-gray-300"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
        />
      </svg>
      <p className="text-lg">
        Enter your details above to see your retirement projection
      </p>
    </div>
  );
}

export default HeatmapPlaceholder;
